import './style.scss'
import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';
import utility from "src/utils/utility"
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import ApiContext from 'src/provider/API/call-service';
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AbsoluteContainer, AppSpan, AppText, Button, Circle, CustomContainer, FlexRow, GridContainer, PageTitle, PageWrapper } from "src/style"
import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from "react-icons/md";
import ProductImage from 'src/assets/img/sample-product-image.svg'
import ProductImage2 from 'src/assets/img/product-image.svg'
import { HorizontalScroll, ProductView } from "src/component";
import { IoIosStar, IoIosStarOutline } from 'react-icons/io';
import { products, categories, apps } from 'src/utils/mock-data';
import { categoryMap, availabilityMap } from 'src/provider/config/constant';
import { Product, ServiceCategory } from 'src/model';

const images = [ProductImage, ProductImage2, ProductImage]


const Discover: React.FC = () => {
    const navigate = useNavigate()
    const { API } = useContext(ApiContext)
    const {info: {authToken}, setInfoProperty} = useContext(AppInfoContext)
    const {decisionBox} = useContext(VisibilityContext)
    const [currentPoint, setCurrentPoint] = useState(0)
    //const [period, setPeriod] = useState(infoPeriods[0])
    const [highestRated, setHighestRated] = useState<Array<any>>([])
    const [mostInstalled, setMostInstalled] = useState<Array<any>>([])
    const [comingSoonProducts, setComingSoonProducts] = useState<Array<any>>([])
    const [categories, setCategories] = useState<Array<any>>([])
    const [institutionApps, setInstitutionApps] = useState<Array<any>>([])
    const [top3Products, setTop3Products] = useState<Array<any>>([])

    useEffect(() => {
        let timer: any = ''
        if (top3Products?.length) {
            timer = window.setTimeout(async () => {
                setCurrentPoint(currentPoint != (top3Products.length - 1) ? currentPoint + 1 : 0)
            }, 5000)
        }
 
        return () => { clearTimeout(timer) }
    }, [currentPoint, top3Products])

    useEffect(() => {
        if (authToken) {
            getProductsBySection()
            handleFetchCategories()
            handleFetchInstitutionApps()
        }
    }, [authToken])

    function getProductsBySection () {
        handleFetchProducts('rating', 'DESC', 'rating')
        handleFetchProducts('installation', 'ASC')
        handleFetchProducts('comingSoon')
    }

    async function handleFetchProducts (type: string, sortOrder: string = 'ASC', sortColumn: string = 'Installation') {
        const response = await API.getProducts({
            pageNumber: 1, pageSize: 10, 
            sortColumn, sortOrder,
            ...(type === 'comingSoon' ? {filter: {integrationStatus: 'ComingSoon'}} : {})
        })
        
        if (response) {
            if (type === 'installation') setMostInstalled(response.data)
            else if (type === 'rating') {
                const responseData = response.data
                setHighestRated(response.data)
                setTop3Products(responseData?.slice(0, 3))
            }
            else if (type === 'comingSoon') setComingSoonProducts(response.data)
        }
    }

    async function handleFetchCategories() {
        const response = await API.getServiceCategories({
            pageNumber: 1, pageSize: 100, 
            sortOrder: 'ASC', sortColumn: 'availabilityStatus'
        })

        if (response) setCategories(response.data)
    }

    async function handleFetchInstitutionApps () {
        const response = await API.getInstitutionApps({isActive: null})
        if (response) setInstitutionApps(response)
    }

    async function handleProduct (product: Product) {
        await setInfoProperty('selectedProduct', product)
        navigate(`/client/discover/product/${product.id}`)
    }

    async function handleSelectedServiceCategory (category: ServiceCategory) {
        await setInfoProperty('selectedServiceCategory', category)
        navigate(`/client/store`)
    }

    return (
        <>
            <PageWrapper>
                <PageTitle 
                    color='#101828' textSize='3' fontWeight="500"
                >
                    Discover
                </PageTitle>
                <CustomContainer topMargin='2'>
                    { top3Products &&
                        top3Products?.map((item, index) => {
                            return (
                                currentPoint === index &&
                                    <FlexRow
                                        width='100' sizeUnit='%'
                                        radius='2' leftMargin='0.5' rightMargin='0.5'
                                        bgColor='#ffffff'
                                        shadow='0px 2px 4px -2px #1018280F, 0px 4px 8px -2px #1018281A'
                                        data-aos="slide-left"
                                        data-aos-duration='500'
                                        style={{overflow: 'hidden'}}
                                        key={index}
                                    >
                                        <CustomContainer
                                            width='75' sizeUnit='%'
                                            height='39.1'
                                        >
                                            {/* <CustomContainer 
                                                width='14' height='5.5'
                                                className='fixed-flex-shape'
                                                style={{overflow: 'hidden'}}
                                            >
                                                <img 
                                                    src={item.logoUrl} 
                                                    className='img-covered' 
                                                    style={{objectFit: 'contain'}}  
                                                />
                                            </CustomContainer> */}
                                            <img 
                                                src={item.screenshotUrls[0]} 
                                                className='img-covered' 
                                                style={{objectFit: 'contain'}}  
                                            />
                                        </CustomContainer>
                                        
                                        <CustomContainer
                                            //width='25' sizeUnit='%'
                                            width='31'
                                            padding='4' minHeight='39.1'
                                            className='fixed-flex-shape'
                                        >
                                            <FlexRow 
                                                gap="1" bottomMargin="1.5" 
                                                width="auto" sizeUnit="" 
                                            >
                                                {
                                                    Array.from(Array(top3Products?.length).keys()).map((item: number) => {
                                                        return (
                                                            <Circle 
                                                                size="1" key={item}
                                                                bgColor={currentPoint === item ? '#409089' : "#ffffff"}
                                                                borderColor={currentPoint === item ? '#409089' : '#ADB5DB'}
                                                                //onClick={() => setCurrentPoint(item)}
                                                            />
                                                        )
                                                    })
                                                }
                                            </FlexRow>
                                            <FlexRow 
                                                width='auto' sizeUnit=''
                                                gap='2.5' bottomMargin='1.4'
                                            >
                                                <Circle 
                                                    size="4.4" 
                                                    borderColor="#131A2D"
                                                    className="fixed-flex-shape"
                                                    style={{visibility: (currentPoint - 1) >= 0 ? "visible" : "hidden"}}
                                                    onClick={() => setCurrentPoint(currentPoint - 1)}
                                                >
                                                    <MdOutlineKeyboardArrowLeft fontSize='2.5rem' />
                                                </Circle>
                                                <Circle 
                                                    size="4.4" 
                                                    borderColor="#131A2D"
                                                    className="fixed-flex-shape"
                                                    style={{visibility: (currentPoint + 1) <= (top3Products.length - 1) ? "visible" : "hidden"}}
                                                    onClick={() => setCurrentPoint(currentPoint + 1)}
                                                >
                                                    <MdOutlineKeyboardArrowRight fontSize='2.5rem' />
                                                </Circle>
                                            </FlexRow>
                                            <AppText 
                                                bottomMargin='1' color='#101828' 
                                                textSize='2' fontWeight='500'
                                                style={{whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word'}}
                                                className='truncate-multiline'
                                            >
                                                {item.name}
                                            </AppText>
                                            <FlexRow 
                                                width='auto' sizeUnit=''
                                                bottomMargin='1' gap='2'
                                            >
                                                <FlexRow width='auto' sizeUnit='' gap='0.5'>
                                                    {
                                                        Array.from(Array(5).keys()).map((num) => {
                                                            return (
                                                                <CustomContainer 
                                                                    width='auto' sizeUnit=''
                                                                    key={num}
                                                                >
                                                                    { item.productStatistic?.averageRating >= (num + 1) ?
                                                                        <IoIosStar fill='#409089' fontSize='1.8rem' />
                                                                        : <IoIosStarOutline fill='#344054' fontSize='1.8rem' />
                                                                    }
                                                                </CustomContainer>
                                                            )
                                                        })
                                                    }
                                                </FlexRow>
                                                <AppSpan textSize='1.25'>{item.productStatistic?.averageRating?.toFixed(1)}</AppSpan>
                                            </FlexRow>
                                            <AppText 
                                                style={{whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word'}}
                                                className='truncate-multiline'
                                            >
                                                {item.description}
                                            </AppText>
                                            <Button
                                                width='100' sizeUnit='%' bgColor='#ffffff'
                                                height='4.4' borderColor='#D0D5DD'
                                                color='#344054' hoverColor='#ffffff'
                                                hoverBgColor='#0D968F' topMargin='3'
                                                hoverBorderColor='#0D968F'
                                            >
                                                See details
                                            </Button>
                                        </CustomContainer>
                                    </FlexRow>
                            )
                        })
                        
                        // <CustomContainer 
                        //     width="75" sizeUnit="%"
                        //     className='product-image-container'
                        // >
                        //     <FlexRow justifyContent="space-between" gap="2">
                        //         <Circle 
                        //             size="4" 
                        //             borderColor="#131A2D"
                        //             className="fixed-flex-shape"
                        //             style={{visibility: (currentPoint - 1) >= 0 ? "visible" : "hidden"}}
                        //             onClick={() => setCurrentPoint(currentPoint - 1)}
                        //         >
                        //             <MdOutlineKeyboardArrowLeft fontSize='2.3rem' />
                        //         </Circle>
                        //         {
                        //             top3Products?.map((item, index) => {
                        //                 return (
                        //                     currentPoint === index &&
                        //                         // <CustomContainer  
                        //                         //     width="90" sizeUnit="%" 
                        //                         //     height="32.2" padding='2'
                        //                         //     bgColor='#EFF1F5'
                        //                         //     //maxWidth='96.8'
                        //                         //     radius='1.1' topMargin='1.5'
                        //                         //     style={{overflow: 'hidden'}}
                        //                         //     //borderColor='#000000'
                        //                         //     key={index}
                        //                         //     data-aos="slide-left"
                        //                         // >
                        //                         //     <img src={item} className='img-covered' style={{objectFit: 'contain'}}  />
                        //                         // </CustomContainer>
                        //                         <FlexRow
                        //                             width="90" sizeUnit="%" 
                        //                             height="39.5" padding='2'
                        //                             bgColor='#EFF1F5' gap='3'
                        //                             radius='1.1' topMargin='1.5'
                        //                             style={{overflow: 'hidden'}}
                        //                             key={index}
                        //                             data-aos="slide-left"
                        //                             justifyContent='space-between'
                        //                         >
                        //                             <CustomContainer width='62' sizeUnit='%'>
                        //                                 <GridContainer bottomMargin='1'>
                        //                                     <CustomContainer 
                        //                                         width='15' height='5.9'
                        //                                         className='fixed-flex-shape'
                        //                                         style={{overflow: 'hidden'}}
                        //                                     >
                        //                                         <img 
                        //                                             src={item.logoUrl} 
                        //                                             className='img-covered' 
                        //                                             style={{objectFit: 'contain'}}  
                        //                                         />
                        //                                     </CustomContainer>
                        //                                 </GridContainer>
                        //                                 <img src={item.screenshotUrls[0]} className='img-covered' style={{objectFit: 'contain'}}  />
                        //                             </CustomContainer>
                        //                             <GridContainer width='29.8' height='100' hUnit='%'>
                        //                                 <CustomContainer>
                        //                                     <AppText 
                        //                                         bottomMargin='1' cursor="pointer"
                        //                                         style={{whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word'}}
                        //                                         className='truncate-multiline'
                        //                                     >
                        //                                         {item.description}
                        //                                     </AppText>
                        //                                     <FlexRow 
                        //                                         justifyContent='space-between' gap='2.5'
                        //                                         bottomMargin='2.5'
                        //                                     >
                        //                                         <FlexRow width='auto' sizeUnit='' gap='0.5'>
                        //                                             {
                        //                                                 Array.from(Array(5).keys()).map((num) => {
                        //                                                     return (
                        //                                                         <CustomContainer 
                        //                                                             width='auto' sizeUnit=''
                        //                                                             key={num}
                        //                                                         >
                        //                                                             { item.productStatistic?.averageRating >= (num + 1) ?
                        //                                                                 <IoIosStar fill='#409089' fontSize='1.8rem' />
                        //                                                                 : <IoIosStarOutline fill='#344054' fontSize='1.8rem' />
                        //                                                             }
                        //                                                         </CustomContainer>
                        //                                                     )
                        //                                                 })
                        //                                             }
                        //                                         </FlexRow>
                        //                                         <AppSpan textSize='1.25'>{item.productStatistic?.averageRating?.toFixed(1)}</AppSpan>
                        //                                     </FlexRow>
                        //                                     <Button
                        //                                         width='100' sizeUnit='%' fontWeight="500"
                        //                                         height='4' radius='0.8' hoverColor='#0D968F'
                        //                                         hoverBgColor='#fff' borderColor='#0D968F'
                        //                                     >
                        //                                         Get it now
                        //                                     </Button>
                        //                                 </CustomContainer>
                        //                             </GridContainer>
                        //                         </FlexRow>
                        //                 )
                        //             })
                        //         }
                        //         <Circle 
                        //             size="4" 
                        //             borderColor="#131A2D"
                        //             className="fixed-flex-shape"
                        //             style={{visibility: (currentPoint + 1) <= (top3Products.length - 1) ? "visible" : "hidden"}}
                        //             onClick={() => setCurrentPoint(currentPoint + 1)}
                        //         >
                        //             <MdOutlineKeyboardArrowRight fontSize='2.3rem' />
                        //         </Circle>
                        //     </FlexRow>

                        //     <GridContainer width="auto" sizeUnit="">
                        //     <FlexRow 
                        //         gap="1" topMargin="2" 
                        //         width="auto" sizeUnit="" 
                        //     >
                        //         {
                        //             Array.from(Array(top3Products?.length).keys()).map((item: number) => {
                        //                 return (
                        //                     <Circle 
                        //                         size="1" key={item}
                        //                         bgColor={currentPoint === item ? '#409089' : "#ffffff"}
                        //                         borderColor={currentPoint === item ? '#409089' : '#ADB5DB'}
                        //                         //onClick={() => setCurrentPoint(item)}
                        //                     />
                        //                 )
                        //             })
                        //         }
                        //     </FlexRow>
                        //     </GridContainer>
                        // </CustomContainer>
                    }

                    <CustomContainer topMargin="2.5">
                        <FlexRow 
                            justifyContent="space-between" gap="2.5"
                        >
                            <AppText textSize="1.9" fontWeight="500" color="#101828">My Apps</AppText>
                            <AppSpan 
                                fontWeight="500" color="#0A756F" 
                                textSize="1.3" cursor="pointer"
                                onClick={() => navigate('/client/settings')}
                            >
                                View all
                            </AppSpan>
                        </FlexRow>
                        <CustomContainer 
                            topMargin="1.5"
                            className='scrollable-container'
                        >
                            <FlexRow gap="2">
                                {
                                    institutionApps?.map((item, index) => {
                                        return (
                                            <GridContainer
                                                key={index} padding='2.5'
                                                width='28.7' height="11.8"
                                                radius="0.8" borderColor="#EAECF0"
                                                shadow='0px 0.72px 1.43px 0px #1018280F, 0px 0.72px 2.15px 0px #1018281A'
                                                onClick={() => handleProduct(item.product)}
                                            >
                                                <CustomContainer width="20" height="4.25" overflow="hidden">
                                                    <img src={item.product?.logoUrl} className='img-covered' style={{objectFit: 'contain'}}  />
                                                </CustomContainer>
                                            </GridContainer>
                                        )
                                    })
                                }
                            </FlexRow>
                        </CustomContainer>
                    </CustomContainer>

                    <CustomContainer topMargin="2.5">
                        <AppText 
                            textSize="1.9" fontWeight="500" 
                            color="#101828" bottomMargin="1.5"
                        >
                            Categories
                        </AppText>
                        <HorizontalScroll
                        >
                            <FlexRow 
                                gap="2" alignItems="stretch" 
                                style={{minWidth: 'fit-content'}}
                            >
                                {
                                    categories.map((item, index) => {
                                        const mappedData = categoryMap[item.id] || categoryMap[11]
                                        const mappedAvailabilityData = availabilityMap[item.availabilityStatus] || availabilityMap["null"]

                                        return (
                                            <GridContainer
                                                padding='1.5' key={index}
                                                width='21.52' minHeight="7"
                                                radius="1.5" bgColor={mappedAvailabilityData.bgColor}
                                                style={{overflow: 'hidden'}}
                                                onClick={() => handleSelectedServiceCategory(item)}
                                            >
                                                <FlexRow
                                                    key={index} 
                                                    justifyContent='space-between'
                                                    gap="2"
                                                >
                                                    <AppText 
                                                        fontWeight="500" color="3A3A3A" width="12.7" cursor='pointer'
                                                        style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis'}}
                                                    >
                                                        {item.name}
                                                    </AppText>
                                                    <Circle 
                                                        size="4" 
                                                        bgColor={mappedAvailabilityData.iconBgColor} 
                                                        className="fixed-flex-shape"
                                                    >
                                                        <img src={mappedData.icon} style={{objectFit: 'contain'}}  />
                                                    </Circle>
                                                </FlexRow>
                                            </GridContainer>
                                        )
                                    })
                                }
                            </FlexRow>
                        </HorizontalScroll>
                    </CustomContainer>

                    <CustomContainer topMargin="2.5">
                        <FlexRow 
                            justifyContent="space-between" gap="2.5"
                        >
                            <AppText textSize="1.9" fontWeight="500" color="#101828">Highest rated</AppText>
                            { highestRated?.length >= 10 &&
                                <AppSpan 
                                    fontWeight="500" color="#0A756F" 
                                    textSize="1.3" cursor="pointer"
                                    onClick={() => navigate('/client/store')}
                                >
                                    View all
                                </AppSpan>
                            }
                        </FlexRow>
                        <CustomContainer 
                            topMargin="1.5"
                            className='scrollable-container'
                        >
                            <FlexRow 
                                gap="2" alignItems='stretch'
                                style={{minWidth: 'fit-content'}}
                            >
                                {
                                    highestRated?.map((product, index) => {
                                        return (
                                            <ProductView
                                                key={index}
                                                product={product}
                                                onClick={() => handleProduct(product)} 
                                            />
                                            // <CustomContainer
                                            //     key={index}
                                            //     width='28.95' minHeight="30"
                                            //     radius="0.8" borderColor="#EAECF0"
                                            //     shadow='0px 1px 2px 0px #1018280F, 0px 1px 3px 0px #1018281A'
                                            // >
                                            //     <CustomContainer 
                                            //         padding='2' bottomPadding='7.3'
                                            //         onClick={() => handleProduct(product)}
                                            //     >
                                            //         <FlexRow width='auto' sizeUnit='' gap='1.5'>
                                            //             <Circle 
                                            //                 size="5" bgColor='#ffffff' 
                                            //                 borderColor='#EAECF0'
                                            //                 className='fixed-flex-shape'
                                            //                 style={{overflow: 'hidden'}}
                                            //             >
                                            //                 <Circle 
                                            //                     size='4'
                                            //                     style={{overflow: 'hidden'}}
                                            //                 >
                                            //                     <img 
                                            //                         src={product.logoUrl} 
                                            //                         className='img-covered' 
                                            //                         style={{objectFit: 'contain'}} 
                                            //                     />
                                            //                 </Circle>
                                            //             </Circle>
                                            //             <AppSpan 
                                            //                 color='#101828' fontWeight="500" textSize='1.6' cursor="pointer"
                                            //                 style={{whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word'}}
                                            //             >
                                            //                 {product.name}
                                            //             </AppSpan>
                                            //         </FlexRow>
                                            //         { product.setupFee ?
                                            //             <AppText 
                                            //                 textSize='2.5' fontWeight="600" 
                                            //                 color='#409089' topMargin='1.8'
                                            //             >
                                            //                 ₦{product.setupFee}
                                            //             </AppText>
                                            //             :
                                            //             <AppText 
                                            //                 textSize='1.6' fontWeight="500" 
                                            //                 color='#0A756F' topMargin='1.8'
                                            //             >
                                            //                 No upfront cost
                                            //             </AppText>
                                            //         }
                                            //         <AppText 
                                            //             topMargin='1' cursor="pointer"
                                            //             style={{whiteSpace: 'normal', wordWrap: 'break-word', overflowWrap: 'break-word'}}
                                            //             className='truncate-multiline'
                                            //         >
                                            //             {product.description}
                                            //         </AppText>
                                            //         <FlexRow 
                                            //             gap='2'
                                            //             topMargin='1'
                                            //         >
                                            //             <FlexRow width='auto' sizeUnit='' gap='0.5'>
                                            //                 {
                                            //                     Array.from(Array(5).keys()).map((item) => {
                                            //                         return (
                                            //                             <CustomContainer 
                                            //                                 width='auto' sizeUnit=''
                                            //                                 key={item}
                                            //                             >
                                            //                                 { product.productStatistic?.averageRating >= (item + 1) ?
                                            //                                     <IoIosStar fill='#409089' fontSize='1.6rem' />
                                            //                                     : <IoIosStarOutline fill='#344054' fontSize='1.6rem' />
                                            //                                 }
                                            //                             </CustomContainer>
                                            //                         )
                                            //                     })
                                            //                 }
                                            //             </FlexRow>
                                            //             <AppSpan textSize='1.25'>{(product.productStatistic?.averageRating || 0)?.toFixed(1)}</AppSpan>
                                            //         </FlexRow>
                                            //     </CustomContainer>
                                            //     <AbsoluteContainer bottom='0' left='0' width='100' sizeUnit='%'>
                                            //         <FlexRow 
                                            //             justifyContent='flex-end'
                                            //             height='5.3' padding='2'
                                            //             style={{borderTop: '1px solid #EAECF0'}}
                                            //         >
                                            //             <AppSpan 
                                            //                 fontWeight="500" color="#0A756F"
                                            //                 //color={product.installed ? "rgba(102,112,133, 0.3)" : "#0A756F"}
                                            //                 textSize="1.3" cursor="pointer"
                                            //                 onClick={() => handleProduct(product)}
                                            //                 //onClick={() => product.installed ? null : handleProductInstallation(product)}
                                            //             >
                                            //                 View product
                                            //             </AppSpan>
                                            //         </FlexRow>
                                            //     </AbsoluteContainer>
                                            // </CustomContainer>
                                        )
                                    })
                                }
                            </FlexRow>
                        </CustomContainer>
                    </CustomContainer>

                    <CustomContainer topMargin="2.5">
                        <FlexRow 
                            justifyContent="space-between" gap="2.5"
                        >
                            <AppText textSize="1.9" fontWeight="500" color="#101828">Most frequently used</AppText>
                            { mostInstalled?.length >= 10 &&
                                <AppSpan 
                                    fontWeight="500" color="#0A756F" 
                                    textSize="1.3" cursor="pointer"
                                >
                                    View all
                                </AppSpan>
                            }
                        </FlexRow>
                        <CustomContainer 
                            topMargin="1.5"
                            className='scrollable-container'
                        >
                            <FlexRow 
                                gap="2" alignItems='stretch'
                                style={{minWidth: 'fit-content'}}
                            >
                                {
                                    mostInstalled?.map((product, index) => {
                                        return (
                                            <ProductView
                                                key={index}
                                                product={product}
                                                onClick={() => handleProduct(product)} 
                                            />
                                        )
                                    })
                                }
                            </FlexRow>
                        </CustomContainer>
                    </CustomContainer>

                    <CustomContainer topMargin="2.5">
                        <FlexRow 
                            justifyContent="space-between" gap="2.5"
                        >
                            <AppText textSize="1.9" fontWeight="500" color="#101828">Coming soon</AppText>
                            { comingSoonProducts?.length >= 10 &&
                                <AppSpan 
                                    fontWeight="500" color="#0A756F" 
                                    textSize="1.3" cursor="pointer"
                                >
                                    View all
                                </AppSpan>
                            }
                        </FlexRow>
                        <CustomContainer 
                            topMargin="1.5"
                            className='scrollable-container'
                        >
                            <FlexRow 
                                gap="2" alignItems='stretch'
                                style={{minWidth: 'fit-content'}}
                            >
                                {
                                    comingSoonProducts?.map((product, index) => {
                                        return (
                                            <ProductView
                                                key={index}
                                                product={product}
                                                isComingSoon
                                                onClick={() => handleProduct(product)} 
                                            />
                                        )
                                    })
                                }
                            </FlexRow>
                        </CustomContainer>
                    </CustomContainer>
                </CustomContainer>
            </PageWrapper>
        </>
    )
}

export default utility.routeData('discover', 'Discover', <Discover/>)
